var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.image.caption
    ? _c("p", { class: _vm.css }, [
        _vm._v("\n  " + _vm._s(_vm.image.caption) + "\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }